import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import NavBar_v03LeftRight from '../../component-library/NavBar_v03a_Responsive_component';

import { IAppConfig, AppConfig } from "../../App_v01_Interfaces";

interface AppConfigProps{
  appConfig: IAppConfig;
}



const Services_v01: React.FC<AppConfigProps> = ({appConfig}) => {
  return (
    <>
      {/* <Navbar_v01 appConfig={appConfig} /> */}
      <NavBar_v03LeftRight appConfig={appConfig} />
      <Container className="my-5">
        <h2>Our Insurance Plans</h2>
        <Row>
            <Col md={4}>
                <Card className="mb-4">
                    <Card.Body>
                        <Card.Title>Basic Plan</Card.Title>
                        <Card.Text>Starting at $500 per year.</Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="mb-4">
                    <Card.Body>
                        <Card.Title>Premium Plan</Card.Title>
                        <Card.Text>Starting at $1000 per year.</Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="mb-4">
                    <Card.Body>
                        <Card.Title>Comprehensive Plan</Card.Title>
                        <Card.Text>Starting at $1500 per year.</Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </Container>
    </>
  );
};

export default Services_v01;
